
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const QueueNotificationModal = ({
  taskId,
  projectId,
  workflowType, // optional: 'generativeai' | 'docking' | 'retrosynthesis'
  onClose,
  onHistory,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  // Detect workflow from props or URL
  const pathname = location.pathname.toLowerCase();

  const isGenerativeAI =
    workflowType === 'generativeai' || pathname.includes('generativeai');

  const isDocking =
    workflowType === 'docking' || pathname.includes('docking');

  const isRetrosynthesis =
    workflowType === 'retrosynthesis' || pathname.includes('retrosynthesis');

  const workflowName = isRetrosynthesis
    ? 'retrosynthesis'
    : isDocking
    ? 'docking'
    : isGenerativeAI
    ? 'generative ai'
    : pathname.split('/').filter(Boolean).pop();

  const handleHistory = () => {
  if (onHistory) {
    onHistory();
    return;
  }

  // Back navigation based on workflow
  if (isRetrosynthesis) {
    navigate(-1);
    return;
  }

  if (isGenerativeAI) {
    navigate(-2);
    return;
  }

  if (isDocking) {
    navigate(-1);
    return;
  }

  // Fallback
  navigate(-1);
};


  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-md bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full">
        <h2 className="text-xl font-semibold mb-4 text-gray-800">
          {isDocking ? 'Docking Job Queued' : 'Request Queued'}
        </h2>

        <p className="text-gray-600 mb-4">
          Your{' '}
          <span className="capitalize font-bold">{workflowName}</span>{' '}
          request has been{' '}
          <span className="font-bold text-purple-600">queued</span>.
          <br />
          Task ID:{' '}
          <span className="font-bold text-purple-600">
            {taskId || 'N/A'}
          </span>
          <br />
          You can track the progress in the history/results page.
        </p>

        <p className="text-sm text-gray-500 mb-6">
          Results will appear once processing is complete.
        </p>

        <div className="flex justify-between space-x-4">
          <button
            onClick={onClose}
            className="flex-1 bg-gray-200 text-gray-800 py-2 rounded-md hover:bg-gray-300 transition-colors"
          >
            Close
          </button>

          <button
            onClick={handleHistory}
            className="flex-1 bg-purple-600 text-white py-2 rounded-md hover:bg-purple-700 transition-colors"
          >
            View History
          </button>
        </div>
      </div>
    </div>
  );
};

export default QueueNotificationModal;